import { Stack, Text, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import React from 'react'
import { useTranslation } from 'react-i18next'

import useNetworkType from '@/hooks/useNetworkType'
import { useAuth } from '@/plugins/auth'

import RootButton from '../Buttons/RootButton'
import NeedHelp from './NeedHelp'

interface NoOnChainRewardsProps {
  nextStep: () => void
}

const NoOnChainRewards: React.FC<NoOnChainRewardsProps> = ({ nextStep }) => {
  const theme = useMantineTheme()
  const { disconnect } = useAuth()
  const { t } = useTranslation()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const { isBetanet } = useNetworkType()
  return (
    <Stack style={{ gap: '20px' }}>
      <Title order={isMobile ? 3 : 2}>
        {t(
          'components.airdrop.noRewards2',
          'Sorry. No platform rewards are linked to your account'
        )}
      </Title>
      <Stack style={{ gap: '20px' }}>
        <Text style={{ fontSize: 14 }}>
          {isBetanet
            ? t(
                'components.airdrop.noActivityBetanet',
                'This account does not have any activity on it prior to the platform rewards cutoff date of April 18, 2024. Try signing in to Betanet with a different login method to find more active accounts.'
              )
            : t(
                'components.airdrop.noActivity',
                'This account doesn’t have any on-chain or Telegram activity linked to it during the airdrop eligibility window from April 26-October 24, 2024. Try signing in with a different login method to find more active accounts, or select “Check Discord” to continue and see if you’re eligible for community rewards.'
              )}
        </Text>
        <Stack style={{ flexDirection: 'row' }}>
          {isBetanet ? (
            <RootButton onClick={disconnect} expand>
              {t('buttons.checkAnotherAccount', 'Check Another Account')}
            </RootButton>
          ) : (
            <RootButton onClick={nextStep} expand>
              {t('buttons.checkDiscord', 'Check Discord')}
            </RootButton>
          )}
        </Stack>
        {!isBetanet && <NeedHelp onChainRewards />}
      </Stack>
    </Stack>
  )
}

export default NoOnChainRewards
